var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"size":"large","type":"text"},on:{"click":_vm.backHome}},[_vm._v("返回首页")]),_c('el-button',{attrs:{"size":"large","type":"text"},on:{"click":_vm.backPrev}},[_vm._v("返回上一页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }